import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "../Screen/Home";
import About from "../Screen/About";
import Product from "../Screen/Product";
import Contact from "../Screen/Contact";
import Cable from "../Screen/Cables";
import Contactor from "../Screen/Contactor";
import Timer from "../Screen/Timer";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/product" element={<Product />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cable" element={<Cable />} />
        <Route path="/contractor" element={<Contactor />} />
        <Route path="/timer" element={<Timer />} />
      </Routes>
    </Router>
  );
}

export default App;
